import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import nav from './_nav';
import './Menu.scss';

class Menu extends Component {

    constructor(props) {
        super(props);

    }

    activeRoute = (routeName) => {
        // console.log(this.props, 'this props')
        // console.log(this.props.location.pathname, routeName, this.props.location.pathname.indexOf('/user/transactio'))
        return this.props.location.pathname.indexOf(routeName) > -1 && 'active-item';
    };

    render() {
        return (
            <div className='menu-horizontal'>
                {nav.items.map((item, index) => {
                    return (
                        <div key={index}
                             onClick={()=>this.props.history.push(item.url)}
                             className={`menu-item ${this.activeRoute(item.url)}`}>
                            {item.name}
                        </div>
                    )
                })}
            </div>
        )
    }
}

function mapStateToProps(state) {
    const {users} = state;
    return {
        permissions: users.permissions,
    };
}

export default connect(mapStateToProps)(withRouter(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js